module.exports = __webpack_public_path__ + "assets/media/morning.a2a74318.mp3";